<template>
  <b-container fluid class="mt-5">
    <b-row>
      <b-col>
          <d-player :options="options"></d-player>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col>
        <b-alert show variant="warning">
          <strong>Para una mejor visualización, mira este tutorial en pantalla completa.</strong><br>
          Para ello, coloca el cursor sobre la pantalla del video y  da clic en el ícono rectangular  que aparece en la esquina inferior derecha.
        </b-alert>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
  import DPlayer from 'vue-dplayer'
  import 'vue-dplayer/dist/vue-dplayer.css'

  export default {
    components: { DPlayer },
    computed: {
      options () {
        return {
          theme: '#FFDD00',
          autoplay: true,
          video: {
            url: `/videos/${this.$route.params.video}.mp4`,
            pic: `/posters/${this.$route.params.video}.png`
          }
        }
      }
    }
  }
</script>